import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const TemplateBuilder = loadAsyncComponent(() => import('./Container'), 'page');
